import { BasePersonalFinancialStatementResource, PersonalFinancialStatementFetchOptions, PersonalFinancialStatementResourceType } from './basePersonalFinancialStatementResource'
import { getNetWorthForDateRange } from '@/services/personalFinancialStatement'
import { log } from '@/utils/logger'
import { RecordSnapshotRetrievalStrategy, TimeValueDataPoint } from 'aven_types'

const LOOKBACK_MONTHS = 3
const TIME_INTERVAL_MS = 24 * 60 * 60 * 1000 // 1 day in milliseconds

export class PersonalFinancialStatementNetworthForDateRangeResource extends BasePersonalFinancialStatementResource<PersonalFinancialStatementResourceType.NET_WORTH_FOR_DATE_RANGE> {
    constructor() {
        super(PersonalFinancialStatementResourceType.NET_WORTH_FOR_DATE_RANGE)
    }

    protected async fetchData(options?: PersonalFinancialStatementFetchOptions): Promise<{
        trendData: TimeValueDataPoint[]
        currentValue: number | null
        changePercent: number | null
    } | null> {
        const now = new Date()
        const startDate = new Date()
        startDate.setMonth(startDate.getMonth() - LOOKBACK_MONTHS)

        log.info('PersonalFinancialStatementNetworthForDateRangeResource.fetchData: Fetching from %{startDate} to %{now}', { startDate, now })

        const response = await getNetWorthForDateRange({
            dateRange: {
                startDate,
                endDate: now,
            },
            timeIntervalMs: TIME_INTERVAL_MS,
            sourceUniqueId: null,
            retrievalStrategy: RecordSnapshotRetrievalStrategy.SINGLE_SOURCE_WATERFALL_HIGHEST_RECORD_COUNT,
            rateLimitingOptions: {
                turnOffRateLimiter: false,
                onlyCountSuccessfulFetchesWhenRateLimiting: true,
            },
            fetchNewRecordSnapshotsOptions: {
                doNotFetchNewRecordsFromSource: false,
                fetchKeyStatusesFromSourceValues: true,
                onlyFetchBetweenMostRecentSnapshotAndCurrentDate: options?.onlyFetchBetweenMostRecentSnapshotAndCurrentDate ?? true,
                fetchSnapshotDateRangeOverride: null,
            },
        })

        if (response.data.success && response.data.payload.length > 0) {
            const trendData = response.data.payload.map((point) => ({
                time: new Date(point.time),
                value: point.value,
            }))

            const firstValue = trendData[0].value
            const lastValue = trendData[trendData.length - 1].value
            const changePercent = firstValue === 0 ? null : ((lastValue - firstValue) / Math.abs(firstValue)) * 100

            log.info('PersonalFinancialStatementNetworthForDateRangeResource.fetchData: Fetched %{count} data points', { count: trendData.length })

            return {
                trendData,
                currentValue: lastValue,
                changePercent,
            }
        } else {
            log.warn('PersonalFinancialStatementNetworthForDateRangeResource.fetchData: No data returned from API')
            return null
        }
    }
}
